module.exports = __webpack_public_path__ + "static/media/chain.811b7f9b.svg";